import { render } from "./pendingTreatmentDetails.vue?vue&type=template&id=39303b16&scoped=true"
import script from "./pendingTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./pendingTreatmentDetails.vue?vue&type=script&lang=js"

import "./pendingTreatmentDetails.vue?vue&type=style&index=0&id=39303b16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39303b16"]])

export default __exports__